import {
    FETCH_BRANCH_CONTENT,
    FETCH_BRANCH_CONTENT_SUCCESS,
    FETCH_BRANCH_CONTENT_FAILED,
    BRANCH_MESSAGE,
    BRANCH_MESSAGE_SUCCESS,
    BRANCH_MESSAGE_FAILED,

} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_BRANCH_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_BRANCH_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_BRANCH_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case BRANCH_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case BRANCH_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case BRANCH_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };

        default:
            return state;
    }
}
